import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Route, HashRouter } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import creatStore from '~redux/store';
import history from '~redux/history';
import TranslationProvider from '~views/translationProvider';

const Welcome = lazy(() => import('./welcome'));
const HPP = lazy(() => import('./hpp'));
const Dropin = lazy(() => import('./dropin'));
const SplitCvc = lazy(() => import('./splitCvc'));
const SplitExpiry = lazy(() => import('./splitExpiry'));
const SplitCardNumber = lazy(() => import('./splitCardNumber'));
const Split3dsFrictionless = lazy(() => import('./split3dsfrictionless'));
const Split3dsChallenge = lazy(() => import('./split3dsChallenge'));
const SplitPaymentRequestButton = lazy(() => import('./splitPaymentRequestButton'));
const SplitFullFeaturedCard = lazy(() => import('./splitFullFeaturedCard'));
const splitQrcode = lazy(() => import('./splitQrcode'));
const SplitRedirect = lazy(() => import('./splitRedirect'));
const QrcodeMockHook = lazy(() => import('./qrcodeMockHook'));
const WechatJsapiCallback = lazy(() => import('./wechatJsapiCallback'));
const CheckoutSuccess = lazy(() => import('./success'));
const SplitCard = lazy(() => import('./splitCard'));
const CheckoutFail = lazy(() => import('./fail'));
const RedirectPage = lazy(() => import('./redirectPage'));
const RedirectPageWechat = lazy(() => import('./redirectPageWechat'));
const PayByLink = lazy(() => import('./payByLink'));

const PAYMENT_ID_REGX = '[a-z0-9-_]+';

const Index: React.FC = () => {
  const store = creatStore();
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <TranslationProvider>
          <Suspense fallback={<Skeleton animation="wave" />}>
            <HashRouter>
              <Route path="/elements/dropin" component={Dropin} />
              <Route path="/standalone/recurring" component={HPP} />
              <Route path={`/standalone/checkout/:intentId(${PAYMENT_ID_REGX})`} component={HPP} />
              <Route path="/elements/cvc" component={SplitCvc} />
              <Route path="/elements/expiry" component={SplitExpiry} />
              <Route path="/elements/card-number" component={SplitCardNumber} />
              <Route path="/elements/3ds-frictionless" component={Split3dsFrictionless} />
              <Route path="/elements/3ds-challenge" component={Split3dsChallenge} />
              <Route path="/elements/payment-request-button" component={SplitPaymentRequestButton} />
              <Route path="/elements/full-featured-card" component={SplitFullFeaturedCard} />
              <Route path="/elements/card" component={SplitCard} />
              <Route path="/pay/:code" component={PayByLink} />
              {/* For wechat element, some live merchant still need this route */}
              <Route path="/elements/wechat" component={splitQrcode} />
              <Route path="/elements/qrcode" component={splitQrcode} />
              <Route path="/elements/redirect" component={SplitRedirect} />
              <Route path="/wechat/jsapi-callback" component={WechatJsapiCallback} />
              <Route path="/qrcode/mock" component={QrcodeMockHook} />
              <Route path="/checkout-success" component={CheckoutSuccess} />
              <Route path="/checkout-fail" component={CheckoutFail} />
              {/* For wechat hpp mweb, need verify domain: https://airwallex.atlassian.net/wiki/spaces/APA/pages/2030476454/Wechat+H5+HPP+flow */}
              <Route path="/page/redirect-wechat" component={RedirectPageWechat} />
              {/* For kakaopay app integration, we need redirect to schema format url */}
              <Route path="/page/redirect" component={RedirectPage} />
              <Route exact={true} path="/" component={Welcome} />
            </HashRouter>
          </Suspense>
        </TranslationProvider>
      </ConnectedRouter>
    </Provider>
  );
};

export default Index;
